import { render, staticRenderFns } from "./BottomPanelReport.vue?vue&type=template&id=24afd075&scoped=true&lang=pug&"
import script from "./BottomPanelReport.vue?vue&type=script&lang=ts&"
export * from "./BottomPanelReport.vue?vue&type=script&lang=ts&"
import style0 from "./BottomPanelReport.vue?vue&type=style&index=0&id=24afd075&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afd075",
  null
  
)

export default component.exports